// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth"
import { getDatabase, ref, child, get } from "firebase/database";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyB7-v04c3BV_s2Ad2eM-ME7MatWZZ2eHP8",
  authDomain: "surge-party.firebaseapp.com",
  databaseURL: "https://surge-party-default-rtdb.firebaseio.com",
  projectId: "surge-party",
  storageBucket: "surge-party.appspot.com",
  messagingSenderId: "454840552753",
  appId: "1:454840552753:web:882abeddb42aec1bcfb410",
  measurementId: "G-F1E41HV8GJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth();
const provider = new GoogleAuthProvider();
const providerApple = new OAuthProvider('apple.com');
export const db = getFirestore(app);

export { auth, provider, providerApple };